import React, { useState } from 'react'
import headerLogo from "../assets/Header Logo.png";
import discord from "../assets/discord.png";
import opensea from "../assets/opensea.png";
import twitter from "../assets/twitter.png";
import { useMediaQuery } from 'react-responsive';

export const handleNavClick=(id)=>{

    document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function Header() {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const HeaderElement=({name, id})=>{
        return(
            <div onClick={()=>handleNavClick(id)}  className={` ${isNavOpen && isMobile ?'block':'hidden'}  sm:block text-white mx-2 text-[8px] relative z-50 cursor-pointer font-title lg:mx-6 lg:text-[18px]  `}>
                {name}
            </div>
        )
    }

    const HeaderLogo=({logo})=>{
        return(
            <div className="text-center flex items-center -ml-3 md:-ml-20  ">
                <img src={logo} className='w-32 mt-[0rem] relative  z-50 mb-3 lg:w-96 lg:ml-[-45px]' alt="" />
            </div>
        )
    }

    const HeaderSocialIcon=({logo, link})=>{
        return(
            <div className="text-center">
                <a href={link} target="_blank" rel="noopener noreferrer">
                <img src={logo} className='w-5 mx-2 relative z-50 cursor-pointer lg:w-10 lg:mx-4 ' alt="" />
                </a>
            </div>
        )
    }
    

    const ConnectWalletBtn=({buttonName})=>{
        return(
            <div className="flex justify-center items-center relative w-20 z-50 sm:w-32 sm:text-[8px] cursor-pointer bg-[gray] text-[4px] font-[Early GameBoy] text-[rgba(108,189,69,1)] h-7 px-1 py-0 ml-1 rounded-2xl font-early md:w-52  lg:text-[13px] lg:h-14 lg:px-3 lg:py-3 lg:ml-10  ">
                <span className='mt-[6px] '>{buttonName}</span>
            </div>
        )
    }

    const handleLearnMore=()=>{
        document.getElementById('CPIntro_id').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    const BurgerButton=()=>{
        return(
            <div onClick={()=> setIsNavOpen((prev)=> !prev)  } className="HAMBURGER-ICON relative z-50 sm:hidden  mobile-menu space-y-2">
                 {
                     isNavOpen?
                     <div className='text-white text-[18px]' >X</div>
                     :
                     <>
                      <span className="block h-0.5 w-5 animate-pulse bg-white"></span>
            <span className="block h-0.5 w-5 animate-pulse bg-white"></span>
            <span className="block h-0.5 w-5 animate-pulse bg-white"></span>
            </>
                 }
            </div>
        )
    }

    const isMobile = useMediaQuery({ query: '(max-width: 667px)' })

  return (
    <div className='Header absolute pl-2 pr-2 top-0 mt-2  flex flex-col w-full min-w-full '>
      <div className="uppderHead flex justify-between 2xl:justify-evenly align-middle h-full flex-wrap">
      <div className="leftHeader flex justify-evenly items-center ">
          <BurgerButton/>
      <HeaderElement name="ROADMAP" id="Utility_id" />
        <HeaderElement name="RARITY" id="rarity_id" />
        <HeaderElement name="WHITELIST" id="rarityTypes_id" />
        <HeaderElement name="TEAM" id="team_id" />
        </div>

        {
            isMobile?
            <div className="rightHeader flex justify-between items-center ">
            <HeaderSocialIcon logo={discord} link={"https://discord.gg/gSxyUEF3qH"} />
        <HeaderSocialIcon logo={twitter} link={"https://twitter.com/CoinPlantsNFT"} />
        <HeaderSocialIcon logo={opensea} />
        <HeaderLogo logo={headerLogo} />
            </div>
            :

            <div className="rightHeader flex justify-evenly items-center ">
        <HeaderLogo logo={headerLogo} />

            <HeaderSocialIcon logo={discord} link={"https://discord.gg/gSxyUEF3qH"} />
        <HeaderSocialIcon logo={twitter} link={"https://twitter.com/CoinPlantsNFT"} />
        <HeaderSocialIcon logo={opensea} />
            </div>
        }
        {/* <HeaderLogo logo={headerLogo} /> */}
        <div className="rightHeader flex  items-center ">
        <ConnectWalletBtn buttonName="Connect wallet" />
            </div>
        
      </div>

      <div className=" relative z-20  mt-5  pl-8 pr-8 flex flex-col items-center  "> 
     <span className="  font-early max-w-fit text-[8px] text-center text-[white] shadow-2xl p-2 shadow-gray lg:text-[12px]">
     Coin Plants is an NFT collection of 2500 succulent JPEG’s that will help <br />
     rebuild our forests!
     </span>
     <div className="btnWrapper flex justify-center mt-2 lg:mt-5 ">
       <div onClick={handleLearnMore} className="mintBtn bg-[#7BD98D] text-center px-10 py-2 rounded-2xl drop-shadow-[0_5px_5px_rgba(0,0,0,0.75)] w-fit text-white font-early text-[8px] lg:px-20 lg:py-4 lg:text-[12px] cursor-pointer">
            LEARN MORE
        </div>
       </div>
      </div>

    </div>
  )
}

export default Header